/** @format */
import {FormState} from './types';

export const DEFAULT_VALUES: FormState = {
  name: '',
  phone: '',
  link: '',
  inn: '',
  comment: '',
};

export const MAX_NAME = 50;

export const MAX_PHONE = 16;

export const MAX_LINK = 100;

export const MIN_INN = 10;

export const MAX_INN = 12;

export const MAX_COMMENT = 1000;

export const ID_FORM_ROOT = 'form-root';

export const ID_FIELDS_LEFT = 'fields-left';

export const ID_SUBMIT_BUTTON = 'submit-button';

export const ID_INPUT_NAME = 'input-name';

export const ID_INPUT_PHONE = 'input-phone';

export const ID_INPUT_LINK = 'input-link';

export const ID_INPUT_INN = 'input-inn';

export const ID_INPUT_COMMENT = 'input-comment';
